import { mapSequenceNumber } from '../../core';
import {
    ApiGetCounterPartyRequestInterface,
    ApiGetCounterPartyResponseInterface,
    GetCounterPartyRequestInterface,
    GetCounterPartyResponseInterface
} from '../interfaces';

export function mapGetCounterPartyRequest(request: GetCounterPartyRequestInterface): ApiGetCounterPartyRequestInterface {
    return {
        key: {
            case_sequence_number: mapSequenceNumber(request.caseSequenceNumber),
        },
        vehicle: {
            license_plate: request.licensePlate,
        },
    };
}

export function mapGetCounterPartyResponse(
    response: ApiGetCounterPartyResponseInterface
): GetCounterPartyResponseInterface {
    return {
        claimObjectId: response.claim_object_id,
        claimObjectDescription: response.claim_object_description,
        motorVehicleMake: response.motor_vehicle_make,
        motorVehicleBrandDescription: response.motor_vehicle_brand_description,
        motorVehicleType: response.motor_vehicle_type,
        motorVehicleTypeDescription: response.motor_vehicle_type_description,
        motorVehicleModel: response.motor_vehicle_model,
        bodyStyle: response.body_style,
        bodyStyleDescription: response.body_style_description,
        buildDate: response.build_date,
        color: response.kleur,
    };
}
